export const GTM_ID_PRODUCTION_HR = 'GTM-THF5WR';
export const GTM_ID_PRODUCTION_DE = 'GTM-THF5WR';
export const GTM_ID_PRODUCTION_SRB = 'GTM-THF5WR';
export const GTM_ID_PRODUCTION_PL = 'GTM-THF5WR';
//Replace null with a Google Tag Manager container id. Create your own for testing.
export const GTM_ID_DEVELOPMENT = '';
